<template>
    <div class="scc-content-block" :class="[`scc-content-block--${backgroundColor}`]">
        <slot />
    </div>
</template>

<script>
import './content-block.scss';
const values = ['primary', 'secondary', 'white', 'grey', 'transparent'];
export default {
    name: 'ContentBlock',
    __editor: {
        fields: {
            backgroundColor: {
                widget: 'select',
                values: values,
            },
        },
    },
    props: {
        backgroundColor: {
            type: String,
            required: false,
            default: 'white',
            validator: function(val) {
                return values.includes(val);
            },
        },
    },
};
</script>
